import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTraminline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M19 56h26" }),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 23,
				cy: 42,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 41,
				cy: 42,
				r: 2
			}),
			/* @__PURE__ */ _jsx("path", { d: "M40.882 6l-3.353 9m-11.176 0L23 6m17 45l7.916 8M16 59l7.916-8" }),
			/* @__PURE__ */ _jsx("rect", {
				strokeLinecap: "square",
				x: 21,
				y: 22,
				width: 22,
				height: 10,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				strokeLinecap: "square",
				x: 16,
				y: 15,
				width: 32,
				height: 36,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 9c11.048-5.333 21.714-5.333 32 0",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgTraminline;
